import { render, staticRenderFns } from "./PIDJd.vue?vue&type=template&id=0208c2ba&scoped=true"
import script from "./PIDJd.vue?vue&type=script&lang=js"
export * from "./PIDJd.vue?vue&type=script&lang=js"
import style0 from "./PIDJd.vue?vue&type=style&index=0&id=0208c2ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0208c2ba",
  null
  
)

export default component.exports